var _defs, _sodipodiNamedview, _style, _g, _metadata;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlecheTitrePacific(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 60.5",
    style: {
      enableBackground: "new 0 0 21 60.5"
    },
    xmlSpace: "preserve",
    sodipodiDocname: "fleche-titre-pacific.svg",
    inkscapeVersion: "1.1.2 (0a00cf5339, 2022-02-04)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs17"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview15",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    showgrid: "false",
    inkscapeZoom: 12.92562,
    inkscapeCx: 10.521739,
    inkscapeCy: 30.211317,
    "inkscapeWindow-width": 1835,
    "inkscapeWindow-height": 1016,
    "inkscapeWindow-x": 0,
    "inkscapeWindow-y": 0,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "Calque_1-2"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\n\t.st0{fill:#DDDDDD;}\n\t.st1{fill:#FFFFFF;stroke:#EF7E60;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title4"
  }, "fleche") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title4"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "5.5,60.5 19.4,30.3 5.5,0 1,0 1,60.5   ",
    id: "polygon6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "0.4,60.5 14.4,30.3 0.4,0   ",
    id: "polyline10",
    style: {
      stroke: "#e52e39",
      strokeOpacity: 1
    }
  }))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata19"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcTitle", null, "fleche"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheTitrePacific);
export default __webpack_public_path__ + "static/media/fleche-titre-pacific.95590130805119737e1c46292edfaebf.svg";
export { ForwardRef as ReactComponent };